import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { articleRouteSearchSchema } from '@pages/crm';
import type { RouterContext } from '@shared/config/router-context';

export const Route = createFileRoute('/$locale/_authenticated/crm/helpdesk/articles')({
  validateSearch: articleRouteSearchSchema,
  beforeLoad: ({ context, params }) => {
    const { auth, ability } = context as RouterContext;
    if (auth.isLoading || !auth.isAuthenticated) return;
    if (!ability.can('read', 'HelpdeskArticle')) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/$locale/unauthorized', params: { locale: params.locale } });
    }
  },
  component: Outlet,
});
